import { createAsyncThunk } from '@reduxjs/toolkit';

import { GatewayService } from '../../services';

export const fetchGateways = createAsyncThunk('gateway/fetchGateways', async (params, { rejectWithValue }) => {
  try {
    const response = await GatewayService.getGateways(params);

    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || 'Failed to fetch gateways');
  }
});

export const fetchGateway = createAsyncThunk('gateway/fetchGateway', async (id, { rejectWithValue }) => {
  try {
    const response = await GatewayService.fetchGateway(id);

    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || 'Failed to fetch gateway');
  }
});

export const fetchAdminGateway = createAsyncThunk('gateway/fetchAdminGateway', async (id, { rejectWithValue }) => {
  try {
    const response = await GatewayService.fetchAdminGateway(id);

    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || 'Failed to fetch admin gateway');
  }
});

export const getAllGateways = createAsyncThunk('gateway/getAllGateways', async (params, { rejectWithValue }) => {
  try {
    const response = await GatewayService.getAllGateways(params);

    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || 'Failed to fetch all gateways');
  }
});

export const searchGateways = createAsyncThunk('gateway/searchGateways', async (params, { rejectWithValue }) => {
  try {
    const response = await GatewayService.searchGateways(params);

    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || 'Failed to fetch gateways');
  }
});

export const createNewGateway = createAsyncThunk(
  'gateway/createNewGateway',
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const response = await GatewayService.createNewGateway(data);
      await dispatch(getAllGateways());

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to fetch gateways');
    }
  }
);

export const updateGateway = createAsyncThunk(
  'gateway/updateGateway',
  async ({ id, data }, { dispatch, rejectWithValue }) => {
    try {
      const response = await GatewayService.updateGateway({ id, data });

      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to update gateway');
    }
  }
);

export const deleteGateway = createAsyncThunk('gateway/deleteGateway', async (data, { dispatch, rejectWithValue }) => {
  try {
    const response = await GatewayService.deleteGateway(data);

    return response?.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || 'Failed to delete gateway');
  }
});
